module.exports = __webpack_public_path__ + "static/media/inSelectArrowUp.eae2dbf0.svg";